import React, { useEffect, useState } from 'react';
import {
  Avatar,
  Button,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Tooltip
} from '@mui/material';
import { styled } from '@mui/material/styles';
import lock from 'src/pages/common/lock.png';
import { checkPermission } from 'src/utils/permission';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchOccupation,
  selectOccupation,
  setDataSuccess
} from 'src/features/staticDataSlice';
import OccupencyCreateModal from 'src/pages/Occupancy/OccupencyCreateModal';


const StyledInputLabel = styled(InputLabel)(({ theme, error }) => ({
  color: error ? theme.palette.error.main : 'inherit',
  background: '#fff',
  padding: '0 4px'
}));

function OccupationList({
  tableListDatas,
  index,
  productId,
  saveRow,
  label,
  handleChange
}) {
  const dispatch = useDispatch();
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [newValue, setNewValue] = useState('');
  const [occupationCreatePermission, setOccupationCreatePermission] = useState(false);

  const occupationData = useSelector(selectOccupation);

  useEffect(() => {
    checkPermission('riskFactors', 'Create').then((permission) => {
      setOccupationCreatePermission(permission);
    });
  }, []);

  useEffect(() => {
    if (newValue) {
      handleChange('occupations', index, newValue);
    }
  }, [newValue]);

  const handleClose = () => {
    fetchOccupation(productId).then((data) =>
      dispatch(setDataSuccess({ dataType: 'occupation', data }))
    );
    setOpenCreateModal(false);
  };

  const error = false; // Add validation logic if needed

  return (
    <>
      <FormControl fullWidth size="small">
        <StyledInputLabel id="select-label-occupations" error={error}>
          {label}
        </StyledInputLabel>
        <Select
          labelId="select-label-occupations"
          id="select-occupations"
          value={tableListDatas[index]?.occupations || ''}
          onChange={(event) => {
            handleChange('occupations', index, event.target.value);
            setNewValue('');
            setTimeout(() => {
              if (document.activeElement instanceof HTMLElement) {
                document.activeElement.blur();
              }
            }, 0);
          }}
          style={{ width: '100%', minWidth: 180 }}
          error={error}
        >
          {occupationData?.map((occupation) => (
            <MenuItem key={occupation?.occupationName} value={occupation?.occupationName}>
              {occupation?.occupationName}
            </MenuItem>
          ))}
          <Tooltip
            title={
              occupationCreatePermission ? (
                ''
              ) : (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Avatar
                    alt=""
                    src={lock}
                    sx={{ width: 24, height: 24, marginRight: 1 }}
                  />
                  You don't have permission to add Occupation
                </div>
              )
            }
          >
            <Button
              variant="text"
              onClick={() => {
                if (occupationCreatePermission) {
                  setOpenCreateModal(true);
                }
              }}
              sx={{ color: occupationCreatePermission ? '#5569ff' : 'grey' }}
            >
              Add More
            </Button>
          </Tooltip>
        </Select>
        {error && (
          <FormHelperText error={true}>
            Validation error
          </FormHelperText>
        )}
      </FormControl>

      {openCreateModal && (
        <OccupencyCreateModal
          handleClose={handleClose}
          productId={productId}
          setNewValue={setNewValue}
        />
      )}
    </>
  );
}

export default OccupationList;
